const config = {
  BASE_API: "http://47.97.228.234:80",
  enterprise: "xxx",
  platform: "xxx",
  projectName: "test"
};

export default config;
